import { writable } from 'svelte/store';
import '../types/session';
import pubsub from 'sweet-pubsub';
let state = {
    receiver: {},
    balance: '',
    receivers: [],
    profiles: [],
    profile: {},
    queue: {
        id: null,
        pending: [],
        completed: []
    },
    is_app_connected: false
};
let session = () => {
    const { subscribe, set, update } = writable(JSON.parse(localStorage.getItem('session')) || state);
    subscribe((value) => {
        localStorage.setItem('session', JSON.stringify(value));
    });
    return {
        subscribe,
        setBalance: (balance) => {
            return update((store) => (Object.assign(Object.assign({}, store), { balance: balance })));
        },
        setReceiver: (data) => {
            const { business_number: { phone_number: number } } = data;
            pubsub.emit('number_selected', { number });
            return update((store) => (Object.assign(Object.assign({}, store), { receiver: data })));
        },
        setReceivers: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), { receivers: data })));
        },
        setProfile: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), { profile: data })));
        },
        setProfiles: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), { profiles: data })));
        },
        setQueue: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), { queue: Object.assign(Object.assign({}, store.queue), data) })));
        },
        clearQueue: () => {
            return update((store) => (Object.assign(Object.assign({}, store), { queue: Object.assign(Object.assign({}, store.queue), { id: null, pending: [] }) })));
        },
        setAppConnection: (data) => {
            return update((store) => (Object.assign(Object.assign({}, store), { is_app_connected: data })));
        },
        logout: () => {
            localStorage.clear();
            return update((store) => state);
        },
    };
};
export default session();
